import { Collapse, IconButton } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import * as React from "react";

const StyledAlert = styled(Alert)({
  alignItems: "center",
  "& .MuiAlert-action": {
    paddingLeft: 8,
  },
});

const DismissButton = styled(IconButton)({
  minWidth: 44,
  minHeight: 44,
});

const DismissibleAlert = React.memo(function DismissibleAlert({
  open,
  severity = "error",
  onDismiss,
  children,
  message,
}) {
  return (
    <Collapse in={open}>
      <StyledAlert
        role="alert"
        severity={severity}
        action={
          onDismiss ? (
            <DismissButton
              aria-label="Dismiss alert"
              size="small"
              onClick={onDismiss}
            >
              <CloseIcon fontSize="small" />
            </DismissButton>
          ) : undefined
        }
      >
        {children || message}
      </StyledAlert>
    </Collapse>
  );
});

DismissibleAlert.displayName = "DismissibleAlert";

DismissibleAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  severity: PropTypes.oneOf(["error", "warning", "info", "success"]),
  onDismiss: PropTypes.func,
  children: PropTypes.node,
  message: PropTypes.string,
};

export default DismissibleAlert;
